import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'
import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migratePopup } from './migrate-popup'

export default function (page: ServerPage) {
  return migrateCommand({
    page,
    structureType: structureTypes.POPUP,
    migrateFunction: migratePopup,
  })
}
